import React from "react";
import styled from "styled-components";

import { MOBILE_BREAKPOINT, TABLET_BREAKPOINT } from "../../constants";

const PANEL_MAX_WIDTH = 420;

// Shared card shell for in-app UI surfaces. Below TABLET the floating
// chrome dissolves into a full-width strip with a single border-top.
function Panel({ children, className, style }) {
  return (
    <Wrapper>
      <Interior className={className} style={style}>
        {children}
      </Interior>
    </Wrapper>
  );
}

const Interior = styled.div`
  position: relative;
  background-color: var(--color-orange-100);
  border-radius: 6px;
  border: 1px solid var(--color-orange-300);
  width: 380px;
  height: 200px;

  @media (max-width: ${TABLET_BREAKPOINT}px) {
    width: 100%;
    max-width: ${PANEL_MAX_WIDTH}px;
    height: 200px;
    border: none;
    /* border-right: 1px solid var(--color-orange-300); */
    border-radius: 0;
    padding: 12px 0;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    height: 160px;
    padding: 4px 0;
  }
`;

// At and below TABLET the cream chrome stays edge-to-edge (continuous
// with the toolbar's cream backdrop in col 1) while the Interior is
// constrained and centered.
const Wrapper = styled.div`
  padding: 8px;
  box-shadow: var(--surface-box-shadow-strong);
  background-color: var(--color-orange-100);
  border-radius: 8px;
  position: relative;

  @media (max-width: ${TABLET_BREAKPOINT}px) {
    width: 100%;
    padding: 0;
    box-shadow: none;
    border-radius: 0;
    border-top: 1px solid var(--color-orange-300);
    display: flex;
    justify-content: center;
  }
`;

export default Panel;
